import React from "react";
import { CheckBox } from "devextreme-react/check-box";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

export default function FormApprovalSetting({ employee, convertDateTime }) {
  const {
    EmployeeCode,
    FullName,
    DateOfBirth,
    Gender,
    DateIn,
    DateOut,
    FinishProbationDate,
    Department,
    Position,
    IsWorker,
    IsForeigner,
    Alias,
    IsIncomeTax,
    IsTradeUnion,
    WorkState,
    LastWorkingDate,
    // TrainExpriedDate,
    IncomeTaxNo,
    TradeUnionDate,
  } = employee;
  return (
    <div>
      <div className="form-readonly">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("EmployeeCode")}</div>
            <div className="form-value">
              <span>{EmployeeCode}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("FullName")}</div>
            <div className="form-value">
              <span>{FullName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("DateOfBirth")}</div>
            <div className="form-value">
              <span>{convertDateTime(DateOfBirth)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("Gender")}</div>
            <div className="form-value">
              <span>{Gender}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("DateIn")}</div>
            <div className="form-value">
              <span>{convertDateTime(DateIn)}</span>
            </div>
          </div>
          {/* <div className="form-group">
            <div className="form-label">
              {formatMessage("TrainExpriedDate")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(TrainExpriedDate)}</span>
            </div>
          </div> */}
          <div className="form-group">
            <div className="form-label">
              {formatMessage("ProbationFinishDate")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(FinishProbationDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("Department")}</div>
            <div className="form-value">
              <span>{Department?.DepartmentName}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("Position")}</div>
            <div className="form-value">
              <span>{Position?.PositionName}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          {/* <div className="form-group">
            <div className="form-label">{formatMessage("Title")}</div>
            <div className="form-value">
              <span>{Position?.Title.TitleName}</span>
            </div>
          </div> */}
          <div className="form-group">
            <div className="form-label">{formatMessage("Alias")}</div>
            <div className="form-value">
              <span>{Alias?.Name}</span>
            </div>
          </div>

          <CheckBox
            defaultValue={IsWorker}
            readOnly={true}
            text={formatMessage("IsWorker")}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsForeigner}
            readOnly={true}
            text={formatMessage("IsForeigner")}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsIncomeTax}
            readOnly={true}
            text={formatMessage("IsIncomeTax")}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={IsTradeUnion}
            readOnly={true}
            text={formatMessage("JoinTradeUnion")}
          />
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("WorkState")}</div>
            <div className="form-value">
              <span>{WorkState}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("LastWorkingDate")}</div>
            <div className="form-value">
              <span>{convertDateTime(LastWorkingDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("DateOut")}</div>
            <div className="form-value">
              <span>{convertDateTime(DateOut)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("IncomeTaxNo")}</div>
            <div className="form-value">
              <span>{IncomeTaxNo}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("TradeUnionDate")}</div>
            <div className="form-value">
              <span>{convertDateTime(TradeUnionDate)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
